import { Check, X, FileSearch, MapPinned, Gavel, Banknote, Send } from "lucide-react";
import { fmtDate } from "@/lib/format";

export const LOAN_STEPS = [
  { key: "diajukan", label: "Diajukan", icon: Send },
  { key: "verifikasi", label: "Verifikasi Dokumen", icon: FileSearch },
  { key: "survei", label: "Survei Lapangan", icon: MapPinned },
  { key: "keputusan", label: "Keputusan", icon: Gavel },
  { key: "pencairan", label: "Pencairan", icon: Banknote },
];

export const loanStage = (l) => l.stage || ({ aktif: "pencairan", lunas: "pencairan", disetujui: "keputusan", ditolak: "keputusan" }[l.status] || "diajukan");

const HINT = {
  diajukan: "Menunggu verifikasi dokumen oleh pengurus.",
  verifikasi: "Dokumen sedang diperiksa petugas kredit.",
  survei: "Petugas akan mengunjungi rumah/tempat usaha Anda.",
  disetujui: "Pinjaman disetujui, dana menunggu dicairkan.",
};

export const LoanTimeline = ({ loan, testid = "loan-timeline" }) => {
  const cur = LOAN_STEPS.findIndex((s) => s.key === loanStage(loan));
  const hist = Object.fromEntries((loan.stage_history || []).map((h) => [h.stage, h]));
  const rejected = loan.status === "ditolak";
  const finished = ["aktif", "lunas"].includes(loan.status);
  return (
    <ol className="relative" data-testid={testid}>
      {LOAN_STEPS.map((s, i) => {
        if (rejected && s.key === "pencairan") return null;
        const doneStep = i < cur || (i === cur && (finished || rejected || s.key === "keputusan"));
        const active = i === cur && !doneStep;
        const bad = rejected && s.key === "keputusan";
        const h = hist[s.key];
        const tone = bad ? "bg-red-600 text-white" : doneStep ? "bg-emerald-600 text-white" : active ? "bg-blue-700 text-white ring-4 ring-blue-200 animate-pulse" : "bg-slate-200 text-slate-500";
        const last = i === LOAN_STEPS.length - 1 || (rejected && s.key === "keputusan");
        return (
          <li key={s.key} className="relative flex gap-3 pb-4 last:pb-0" data-testid={`${testid}-step-${s.key}`} data-state={bad ? "rejected" : doneStep ? "done" : active ? "active" : "todo"}>
            {!last && <span className={`absolute left-[15px] top-8 bottom-0 w-0.5 ${i < cur ? "bg-emerald-500" : "bg-slate-200"}`} />}
            <span className={`relative h-8 w-8 rounded-full flex items-center justify-center shrink-0 ${tone}`}>
              {bad ? <X className="h-4 w-4" /> : doneStep ? <Check className="h-4 w-4" /> : <s.icon className="h-4 w-4" />}
            </span>
            <div className="pt-1 min-w-0">
              <div className={`text-[13px] font-bold ${bad ? "text-red-700" : doneStep || active ? "text-[#0b1437]" : "text-slate-400"}`}>
                {s.key === "keputusan" && h?.result ? `${s.label}: ${h.result === "disetujui" ? "Disetujui" : "Ditolak"}` : s.label}
              </div>
              {h && <div className="text-[11px] text-slate-500">{fmtDate(h.at)}</div>}
              {h?.note && s.key !== "diajukan" && <div className="text-[11.5px] text-slate-700 mt-0.5">{h.note}</div>}
              {active && <div className="text-[11.5px] text-blue-700 mt-0.5">{HINT[s.key]}</div>}
              {s.key === "keputusan" && loan.status === "disetujui" && <div className="text-[11.5px] text-blue-700 mt-0.5">{HINT.disetujui}</div>}
            </div>
          </li>
        );
      })}
    </ol>
  );
};
